import Icon from '../components/Icon.vue'

Icon.register({
  'volume-off': {
    width: 257,
    height: 512,
    paths: [
      {
        d: 'M216.4 71L127.4 160H25.3C12.1 160 1.3 170.7 1.3 184V328C1.3 341.3 12.1 352 25.3 352H127.4L216.4 440.9C231.4 456 257.3 445.4 257.3 424V88C257.3 66.6 231.4 56 216.4 71z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-off.js
// module id = CHnS
// module chunks = 144